import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5000";

const flowAPI = axios.create({
  baseURL: `${API_BASE}/api/flows`,
  headers: { "Content-Type": "application/json" },
});

// Add auth token to all requests
flowAPI.interceptors.request.use((config) => {
  const token = localStorage.getItem("userAccessToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Create new flow
export const createFlow = async (token, flowData) => {
  return flowAPI.post("/", flowData, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

// Update existing flow
export const updateFlow = async (token, flowId, flowData) => {
  return flowAPI.put(`/${flowId}`, flowData, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

// Get all flows for user
export const getFlows = async (token, params = {}) => {
  return flowAPI.get(`/`, {
    headers: { Authorization: `Bearer ${token}` },
    params,
  });
};

// Get flows by phone ID
export const getFlowsByPhoneId = async (token, phoneId) => {
  return flowAPI.get(`/flowByWaAccountId/${phoneId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

// Get flow by ID
export const getFlowById = async (token, flowId) => {
  return flowAPI.get(`/${flowId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

// Delete flow
export const deleteFlow = async (token, flowId) => {
  return flowAPI.delete(`/${flowId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

// Toggle flow active/inactive
export const toggleFlowStatus = async (token, flowId, isActive) => {
  return flowAPI.patch(
    `/${flowId}/toggle`,
    { isActive },
    { headers: { Authorization: `Bearer ${token}` } }
  );
};

// Generate flow using AI
export const generateFlowWithAI = async (token, description, flowName) => {
  return flowAPI.post(
    "/generate",
    { description, flowName },
    { headers: { Authorization: `Bearer ${token}` } }
  );
};

// Allocate flow to a WhatsApp phone
export const allocateFlowToPhone = async (token, flowId, whatsappAccountId) => {
  return flowAPI.post(
    `/${flowId}/allocate`,
    { whatsappAccountId },
    { headers: { Authorization: `Bearer ${token}` } }
  );
};

// Deallocate flow from a WhatsApp phone
export const deallocateFlowFromPhone = async (
  token,
  flowId,
  whatsappAccountId
) => {
  return flowAPI.post(
    `/${flowId}/deallocate`,
    { whatsappAccountId },
    { headers: { Authorization: `Bearer ${token}` } }
  );
};

export default flowAPI;
